import http from './http';

export function fetchQuotaRecords(params) {
  return http.get('/quota-records', { params });
}
